import { createAsyncThunk } from "@reduxjs/toolkit";
import campaignApi from 'api/campaignApi';
import { formatQueryParams } from "helpers/format";

export const getCampaignCars = createAsyncThunk("Campaign Cars", async (params: any = {}) => {
  try {
    const response = await campaignApi.campaignCars(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getCampaignAppTechs = createAsyncThunk("Campaign AppTechs", async (params: any = {}) => {
  try {
    const response = await campaignApi.campaignAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getAppTechs = createAsyncThunk("AppTechs", async (params: any = {}) => {
  try {
    const response = await campaignApi.appTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getTemplateTitleAppTechs = createAsyncThunk("Template AppTech - Title", async (params: any = {}) => {
  try {
    const response = await campaignApi.templateAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getTemplateImageAppTechs = createAsyncThunk("Template AppTech - Image", async (params: any = {}) => {
  try {
    const response = await campaignApi.templateAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getTemplateLeadParagraphAppTechs = createAsyncThunk("Template AppTech - LeadParagraph", async (params: any = {}) => {
  try {
    const response = await campaignApi.templateAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getTemplateContentParagraphAppTechs = createAsyncThunk("Template AppTech - ContentParagraph", async (params: any = {}) => {
  try {
    const response = await campaignApi.templateContentParagraphAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getTemplateClosingParagraphAppTechs = createAsyncThunk("Template AppTech - ClosingParagraph", async (params: any = {}) => {
  try {
    const response = await campaignApi.templateAppTechs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getCampaignGoldPrices = createAsyncThunk("Campaign Gold Prices", async (params: any = {}) => {
  try {
    const response = await campaignApi.campaignGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getSourceGoldPrices = createAsyncThunk("Sources Gold Price", async (params: any = {}) => {
  try {
    const response = await campaignApi.sourceGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getSubjectGoldPrices = createAsyncThunk("Subjects Gold Price", async (params: any = {}) => {
  try {
    const response = await campaignApi.subjectGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getBodyGoldPrices = createAsyncThunk("Bodies Gold Price", async (params: any = {}) => {
  try {
    const response = await campaignApi.bodyGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getArticleGoldPrices = createAsyncThunk("Articles Gold Price", async (params: any = {}) => {
  try {
    const response = await campaignApi.articleGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getArticleGoldPricesNormal = async (params: any = {}) => {
  try {
    const response = await campaignApi.articleGoldPrices(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


// ===== Vote ====

export const getCampaignVotes = createAsyncThunk("Campaign Votes", async (params: any = {}) => {
  try {
    const response = await campaignApi.campaignVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getSubjectVotes = createAsyncThunk("Subjects Vote", async (params: any = {}) => {
  try {
    const response = await campaignApi.subjectVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getBodyVotes = createAsyncThunk("Bodies Vote", async (params: any = {}) => {
  try {
    const response = await campaignApi.bodyVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getArticleVotes = createAsyncThunk("Articles Vote", async (params: any = {}) => {
  try {
    const response = await campaignApi.articleVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getArticleVotesNormal = async (params: any = {}) => {
  try {
    const response = await campaignApi.articleVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


// ===== Vote Keyword ====

export const getKeywordVotes = createAsyncThunk("Keyword Votes", async (params: any = {}) => {
  try {
    const response = await campaignApi.keywordVotes(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const postKeywordVote = async (data: any = {}) => {
  try {
    const response = await campaignApi.postKeywordVote(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putKeywordVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putKeywordVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putTagKeywordVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putTagKeywordVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCampaignVoteKeywords = createAsyncThunk("Campaign Vote Keyword", async (params: any = {}) => {
  try {
    const response = await campaignApi.campaignVoteKeywords(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const allBodyVoteKeyword = async (params: any = {}) => {
  try {
    const response = await campaignApi.allBodyVoteKeyword(params)
    return response;
  } catch (error) {
    return error;
  }
};


// ===== Car =====
export const getAllCampaignCar = async (params: any = {}) => {
  try {
    const response = await campaignApi.allCampaignCar(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getCampaignCar = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getCampaignCar(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postCampaignCar = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaignCar(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaignCar = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaignCar(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putStatusCampaignCar = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putStatusCampaignCar(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiCampaignCar = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiCampaignCar(data);
    return response;
  } catch (error) {
    return error;
  }
};


// ====== Campaign App Tech =====
export const getAllCampaignAppTech = async (params: any = {}) => {
  try {
    const response = await campaignApi.allCampaignAppTech(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getCampaignAppTech = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getCampaignAppTech(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postCampaignAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaignAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaignAppTech = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaignAppTech(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putStatusCampaignAppTech = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putStatusCampaignAppTech(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiCampaignAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiCampaignAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};


// ====== App Tech =====
export const allAppTech = async (params: any = {}) => {
  try {
    const response = await campaignApi.allAppTech(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getAppTech = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getAppTech(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.postAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putAppTech = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putAppTech(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const generateNewContentParagraphAppTech = async (dataForm: any = {}) => {
  try {
    const response = await campaignApi.generateNewContentParagraphAppTech(dataForm);
    return response;
  } catch (error) {
    return error;
  }
};

// ====== Template App Tech =====
export const allTemplateAppTech = async (params: any = {}) => {
  try {
    const response = await campaignApi.allTemplateAppTech(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateAppTech = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getTemplateAppTech(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postTemplateAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.postTemplateAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putTemplateAppTech = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putTemplateAppTech(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiTemplateAppTech = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiTemplateAppTech(data);
    return response;
  } catch (error) {
    return error;
  }
};

// ====== Campaign Gold Prices =====
export const getAllCampaignGoldPrice = async (params: any = {}) => {
  try {
    const response = await campaignApi.allCampaignGoldPrice(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getCampaignGoldPrice = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getCampaignGoldPrice(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postCampaignGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaignGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaignGoldPrice = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaignGoldPrice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putStatusCampaignGoldPrice = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putStatusCampaignGoldPrice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiCampaignGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiCampaignGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getJSONSourceGoldPrice = async (params: any = {}) => {
  try {
    const response = await campaignApi.getJSONSourceGoldPrice(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const allSourceGoldPrice = async (params: any = {}) => {
  try {
    const response = await campaignApi.allSourceGoldPrice(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postSourceGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.postSourceGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putSourceGoldPrice = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putSourceGoldPrice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteSourceGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteSourceGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const allSubjectGoldPrice = async (params: any = {}) => {
  try {
    const response = await campaignApi.allSubjectGoldPrice(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postSubjectGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.postSubjectGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putSubjectGoldPrice = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putSubjectGoldPrice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteSubjectGoldPrice = async (id: string | number) => {
  try {
    const response = await campaignApi.deleteSubjectGoldPrice(id);
    return response;
  } catch (error) {
    return error;
  }
};



export const allBodyGoldPrice = async (params: any = {}) => {
  try {
    const response = await campaignApi.allBodyGoldPrice(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postBodyGoldPrice = async (data: any = {}) => {
  try {
    const response = await campaignApi.postBodyGoldPrice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putBodyGoldPrice = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putBodyGoldPrice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteBodyGoldPrice = async (id: string | number) => {
  try {
    const response = await campaignApi.deleteBodyGoldPrice(id);
    return response;
  } catch (error) {
    return error;
  }
};


// Vote

export const allTemplateChart = async (params: any = {}) => {
  try {
    const response = await campaignApi.allTemplateChart(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const allCategoryVote = async (params: any = {}) => {
  try {
    const response = await campaignApi.allCategoryVote(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const getAllCampaignVote = async (params: any = {}) => {
  try {
    const response = await campaignApi.allCampaignVote(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getCampaignVote = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getCampaignVote(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postCampaignVote = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaignVote(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaignVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaignVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postCampaignVoteKeyword = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaignVoteKeyword(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaignVoteKeyword = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaignVoteKeyword(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putStatusCampaignVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putStatusCampaignVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMultiCampaignVote = async (data: any = {}) => {
  try {
    const response = await campaignApi.deleteMultiCampaignVote(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const allSubjectVote = async (params: any = {}) => {
  try {
    const response = await campaignApi.allSubjectVote(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postSubjectVote = async (data: any = {}) => {
  try {
    const response = await campaignApi.postSubjectVote(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putSubjectVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putSubjectVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteSubjectVote = async (id: string | number) => {
  try {
    const response = await campaignApi.deleteSubjectVote(id);
    return response;
  } catch (error) {
    return error;
  }
};



export const allBodyVote = async (params: any = {}) => {
  try {
    const response = await campaignApi.allBodyVote(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postBodyVote = async (data: any = {}) => {
  try {
    const response = await campaignApi.postBodyVote(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putBodyVote = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putBodyVote(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteBodyVote = async (id: string | number) => {
  try {
    const response = await campaignApi.deleteBodyVote(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const allVariablesTemplateVote = async (params: any = {}) => {
  try {
    const response = await campaignApi.allVariablesTemplateVote(params)
    return response;
  } catch (error) {
    return error;
  }
};


//
export const postCreateNewsOfCampaign = async (id: number | string, data: any = {}) => {
  try {
    const response = await campaignApi.postCreateNewsOfCampaign(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

